<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '3px'}" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
    <div class="content-wrapper">
        <div class="content-detached">
            <div class="content-body">
                <app-search-bar [config]="configLocal.barraBusqueda"
                    [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [filtroEstadoPlan]="true"
                    (busqueda)="searchElementsByFilter($event)"></app-search-bar>
                <div class="row">
                    <div class="col-12">
                        <div class="card card-custom">
                            <div class="card-header">
                                <h4 class="card-title">Mantenedor Proveedor de Correo</h4>
                            </div>
                            <div class="card-head">
                                <div class="heading-elements mt-0">

                                    <button class="btn btn-warning float-right mr-5 mt-5" (click)="exportToExcel()"
                                        *ngIf="permissions.getPermission('30-15-10').asignado">
                                        <i class="flaticon-download-1"></i>
                                        Exportar
                                    </button>
                                    <button class="btn btn-success float-right mr-5 mt-5"
                                        (click)="openAddTipoProveedorCorreoModal(addTipoProveedorCorreoModal)"
                                        *ngIf="permissions.getPermission('30-15-12').asignado">
                                        <i class="flaticon-add-circular-button"></i>
                                        Agregar Proveedor de Correo
                                    </button>
                                </div>
                            </div>
                            <div class="col-1">
                                <ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [multiple]="false"
                                    [clearable]="false" (change)="setPageSize()">
                                    <option *ngFor="let option of page.pageSizes" [value]="option"></option>
                                </ng-select>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                    <ngx-datatable #table class="material" [rows]="rowsMantenedor" [columnMode]="'flex'"
                                        [headerHeight]="50" [footerHeight]="50" [rowHeight]="70" fxFlex="auto"
                                        [externalPaging]="true" [count]="page.totalElements" [offset]="page.pageNumber"
                                        [limit]="page.pageSize" (page)="setPage($event)"
                                        [messages]="{emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false}">

                                        <ngx-datatable-column name="rut" [flexGrow]="4" [sortable]="false"
                                            [resizeable]="false">
                                            <ng-template let-column="column" ngx-datatable-header-template>
                                                <span class="text-table-alignment">Nombre</span>
                                            </ng-template>
                                            <ng-template ngx-datatable-cell-template let-row="row"><span
                                                    class="text-table-alignment">{{row.nombre}}</span>
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column name="Acciones" [flexGrow]="5" [sortable]="false"
                                            [resizeable]="false">
                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                <a class="primary edit mr-1 mrless"
                                                    ngbTooltip="Detalle Proveedor de Correo"
                                                    (click)="openShowTipoProveedorCorreoModal(detailTipoProveedorCorreoModal,row)"
                                                    *ngIf="permissions.getPermission('30-15-16').asignado">
                                                    <div
                                                        class="icon-circle bg-warning text-center align-middle pt-info-button">
                                                        <fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
                                                    </div>
                                                </a>
                                                <a class="primary edit mr-1 mrless"
                                                    ngbTooltip="Editar Proveedor de Correo"
                                                    (click)="openEditTipoProveedorCorreoModal(editTipoProveedorCorreoModal,row)"
                                                    *ngIf="permissions.getPermission('30-15-14').asignado">
                                                    <div
                                                        class="icon-circle bg-info text-center align-middle pt-info-button">
                                                        <fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
                                                    </div>
                                                </a>
                                                <a class="primary edit mr-1 mrless" ngbTooltip="Descargar Plantilla" id="mantenedor-tipo-proveedor-correo.component_Descargar_Plantilla"
                                                    *ngIf="permissions.getPermission('30-15-14').asignado">
                                                    <div
                                                        class="icon-circle bg-success text-center align-middle pt-info-button">
                                                        <fa-icon class="fas fa-download"></fa-icon>
                                                    </div>
                                                </a>

                                                <a *ngIf="permissions.getPermission('30-15-18').asignado && row.activo"
                                                    class="primary edit mr-1 mrless"
                                                    ngbTooltip="Desactivar Proveedor de Correo" [swal]="{
                                                    title: 'Confirmación',
                                                    text: '¿Está seguro de desactivar este Proveedor de Correo?',
                                                    confirmButtonText: 'Desactivar',
                                                    cancelButtonText: 'Cancelar',
                                                    showCancelButton: true,
                                                    confirmButtonColor:'#F64E60'
                                                }" (confirm)="deactivateTipoProveedorCorreo(row)">
                                                    <div
                                                        class="icon-circle bg-danger text-center align-middle pt-info-button">
                                                        <fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
                                                    </div>
                                                </a>
                                                <a *ngIf="permissions.getPermission('30-15-18').asignado && !row.activo"
                                                    class="primary edit mr-1 mrless"
                                                    ngbTooltip="Activar Proveedor de Correo" [swal]="{
                                                    title: 'Confirmación',
                                                    text: '¿Está seguro de activar este Proveedor de Correo?',
                                                    confirmButtonText: 'Activar',
                                                    cancelButtonText: 'Cancelar',
                                                    showCancelButton: true,
                                                    confirmButtonColor:'#F64E60'
                                                }" (confirm)="activateTipoProveedorCorreo(row)">
                                                    <div
                                                        class="icon-circle bg-success text-center align-middle pt-info-button">
                                                        <fa-icon icon="check-circle" class="fa-lg text-white"></fa-icon>
                                                    </div>
                                                </a>
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #addTipoProveedorCorreoModal let-d="dismiss" let-c="close">
    <div class="modal-lg">
        <div class="modal-header">
            <div class="modal-wizard-label">
                <div class="modal-wizard-title">Agregar Proveedor de Correo</div>
                <div class="modal-wizard-desc">Ingrese datos del nuevo Proveedor de Correo </div>
            </div>
        </div>
        <div class="modal-body">
            <app-tipo-correo-proveedor-entry [detailMode]="false"
                (sendCloseRequestEmitter)="closeAddTipoProveedorCorreoModal()"
                (sendTipoProveedorCorreoRequest)="sendNewTipoProveedorCorreo($event)"></app-tipo-correo-proveedor-entry>
        </div>
    </div>
</ng-template>
<ng-template #editTipoProveedorCorreoModal>
    <div class="modal-lg">
        <div class="modal-header">
            <div class="modal-wizard-label">
                <div class="modal-wizard-title">Editar Proveedor de Correo</div>
                <div class="modal-wizard-desc">Modifica los datos del Proveedor de Correo</div>
            </div>
        </div>
        <div class="modal-body">
            <app-tipo-correo-proveedor-entry [detailMode]="false" [editMode]="true"
                [TipoProveedorCorreoToEdit]="selectedTipoProveedorCorreo"
                (sendCloseRequestEmitter)="closeEditTipoProveedorCorreoModal()"
                (sendTipoProveedorCorreoRequest)="editTipoProveedorCorreoRequest($event)">
            </app-tipo-correo-proveedor-entry>
        </div>
    </div>
</ng-template>
<ng-template #detailTipoProveedorCorreoModal>
    <div class="modal-lg">
        <div class="modal-header">
            <div class="modal-wizard-label">
                <div class="modal-wizard-title">Detalle Proveedor de Correo</div>
                <div class="modal-wizard-desc">Se muestran los detalles del Proveedor de Correo</div>
            </div>
        </div>
        <div class="modal-body">
            <app-tipo-correo-proveedor-entry [detailMode]="true" [editMode]="true"
                [TipoProveedorCorreoToEdit]="selectedTipoProveedorCorreo"
                (sendCloseRequestEmitter)="closeShowTipoProveedorCorreoModal()"></app-tipo-correo-proveedor-entry>
        </div>
    </div>
</ng-template>